import { useQueryParam } from './useQueryParam';
import { useQueryUrl } from './useQueryUrl';
import { useCloseDialog } from './useCloseDialog';
import { useMemo } from 'react';

interface IOptions {
  replace: boolean;
}

export const useDialog = (dialogName: string, dialogParam = 'dialog', options: Partial<IOptions> = {}) => {
  const fullOptions = useMemo<IOptions>(
    () => ({
      replace: true,
      ...options,
    }),
    [options]
  );

  const isOpen = useQueryParam(dialogParam) === dialogName;
  const openUrl = useQueryUrl(dialogParam, dialogName);
  const closeUrl = useQueryUrl(dialogParam, null);
  const close = useCloseDialog(void 0, [dialogParam], fullOptions);

  return {
    isOpen,
    openUrl,
    close,
    closeUrl,
  };
};
